import { EXTERNAL_LINKS } from '@/constants/routes';

import type { ArticleSocialSection } from '@/components/articles';

export const articleSocial: ArticleSocialSection = {
  heading: {
    content: 'Follow Us',
    styles: { p: 'text-base text-theme-primary font-bold' },
  },
  socials: {
    facebook: {
      url: EXTERNAL_LINKS.FACEBOOK,
      iconUrl: '/images/blogs/facebook.svg',
      number: {
        content: '600+',
        styles: { p: 'text-base text-theme-primary ' },
      },
    },
    instagram: {
      url: EXTERNAL_LINKS.INSTAGRAM,
      iconUrl: '/images/blogs/instagram.svg',
      number: {
        content: '3.2K+',
        styles: { p: 'text-base text-theme-primary' },
      },
    },
    linkedin: {
      url: EXTERNAL_LINKS.LINKEDIN,
      iconUrl: '/images/blogs/linkedin.svg',
      number: {
        content: '30.7K+',
        styles: { p: 'text-base text-theme-primary' },
      },
    },
    youtube: {
      url: EXTERNAL_LINKS.YOUTUBE,
      iconUrl: '/images/blogs/youtube.svg',
      number: {
        content: '300+',
        styles: { p: 'text-base text-theme-primary' },
      },
    },
  },
};
